<template>
  <gg-modal :is-active="dialog" @close="close">
    <template #toolbar>
      Edit Cron Job
    </template>
    <template #body>
      <cron-job-form :line-key="cromJobObj.linekey"
                     :beginning-cron="cromJobObj"
                     ref="cronJobForm"
                     :actions="false"
                     @start-loading="loading = true"
                     @end-loading="loading = false"
                     @job-updated="actionCompleted"
                     @cancel="close"></cron-job-form>
    </template>
    <template #actions>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn :loading="loading" @click="update">Update</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { cronObjectToString, parseCronString } from '@/helpers/cron'
import CronJobForm from './CronJobForm'

export default {
  name: 'EditCronJobDialog',
  components: {
    CronJobForm,
  },
  props: {
    job: {
      type: Object,
      required: true,
    },
    opened: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    },
    cromJobObj () {
      const job = parseCronString(cronObjectToString(this.job)) // clear job object
      return {
        job,
        linekey: this.job.linekey,
        command: this.job.command,
      }
    }
  },
  methods: {
    update () {
      this.$refs.cronJobForm.submit()
    },
    close () {
      this.$emit('close')
    },
    actionCompleted () {
      this.$emit('job-updated')
      this.close()
    },
  },
}
</script>
